import { render } from "./NotificationsButton.vue?vue&type=template&id=cee6f7c6&scoped=true"
import script from "./NotificationsButton.vue?vue&type=script&lang=js"
export * from "./NotificationsButton.vue?vue&type=script&lang=js"

import "./NotificationsButton.vue?vue&type=style&index=0&id=cee6f7c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cee6f7c6"]])

export default __exports__